import Definition from "./Definition";
export default Definition;
